import React from 'react';
import './style.scss'

function Divider(props) {    
    const { darkMode, customClass } = props;
    return (
        <div className={`${customClass ? customClass : ''}`}>
            <div className={`divider-area ${darkMode ? 'dotted-dark' : 'normal-dotted'}`} />
        </div>
    );
};

export default Divider;